<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div
      class="modal fade"
      id="notification-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">
                {{ $t("notifications.notifications_columns") }}
              </h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-article"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.title") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.title.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-text-recognition"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.notification_text") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.body.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="firstname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-notification"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.type.type") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.type.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-mail-down"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.receiver") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.receiver.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-send"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.sender") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.sender.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-photo-scan"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.image") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.image.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-progress"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.status.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-plus"></i>
                        <span class="custom-option-title">
                          {{ $t("notifications.created_at") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.created_at.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="image" tabindex="-1" aria-hidden="true">
      <div
        class="modal-dialog modal-s modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content ">
          <div class="modal-body p-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <img class="w-100" src="@/assets/img/backgrounds/1.jpg" />
          </div>
        </div>
      </div>
    </div>

    <notificationsAdd
      v-if="
        showAddNotification && hasPrivilege('notifications_push_notifications')
      "
      @updated="
        showAddNotification = false;
        applyFilters();
      "
    />
    <notificationsAuto
      v-if="
        showAutoNotfications &&
          hasPrivilege('notifications_edit_auto_notifications')
      "
      @updated="
        showAutoNotfications = false;
        applyFilters();
      "
    />
    <notificationsWhatsapp
      v-if="
        showWhatsappNotifications &&
          hasPrivilege('notifications_wa_notifications')
      "
      @updated="
        showWhatsappNotifications = false;
        applyFilters();
      "
    />
    <NotificationsSms
      v-if="
        showSmsNotifications &&
          hasPrivilege('notifications_edit_auto_notifications')
      "
      @updated="
        showSmsNotifications = false;
        applyFilters();
      "
    />
    <NotificationsTelegram
      v-if="
        showTelegramNotifications &&
          hasPrivilege('notifications_tg_notifications')
      "
      @updated="
        showTelegramNotifications = false;
        applyFilters();
      "
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-center flex-column flex-md-row justify-content-md-start gap-2 mt-6 mt-md-2 mt-lg-2 mt-xl-2 mt-xxl-2 flex-wrap"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    type="button"
                    v-if="hasPrivilege('notifications_push_notifications')"
                    @click.prevent="showAddNotificationDialog"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{
                        $t("notifications.new_notification")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-warning waves-effect waves-light"
                    tabindex="0"
                    type="button"
                    v-if="hasPrivilege('notifications_edit_auto_notifications')"
                    @click.prevent="showAutoNotificationsDialog"
                  >
                    <span>
                      <i class="ti ti-brightness-auto"></i>
                      <span class="lg:inline-block hidden">{{
                        $t("notifications.automatic_notifications_app")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                v-if="settings.features.wa"
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-success waves-effect waves-light"
                    tabindex="0"
                    type="button"
                    v-if="hasPrivilege('notifications_wa_notifications')"
                    @click.prevent="showWhatsappNotificationsDialog"
                  >
                    <span>
                      <i class="ti ti-brand-whatsapp"></i>
                      <span class="lg:inline-block hidden">{{
                        $t("notifications.type.whatsapp")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-info waves-effect waves-light"
                    tabindex="0"
                    type="button"
                    v-if="hasPrivilege('notifications_tg_notifications')"
                    @click.prevent="showTelegramNotificationsDialog"
                  >
                    <span>
                      <i class="ti ti-brand-telegram"></i>
                      <span class="lg:inline-block hidden">{{
                        $t("notifications.type.telegram")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div class="dt-buttons btn-group flex-wrap" bis_skin_checked="1">
                <button
                  class="btn btn-warning waves-effect waves-light"
                  tabindex="0"
                  type="button"
                  disabled
                  v-if="hasPrivilege('notifications_edit_auto_notifications')"
                  @click.prevent="showSmsNotificationsDialog"
                >
                  <span>
                    <i class="ti ti-message"></i>
                    <span class="lg:inline-block hidden">{{
                      $t("notifications.sms_notifications")
                    }}</span>
                  </span>
                </button>
              </div>
            </div>
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-end flex-column flex-md-row gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('notifications_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('notifications_table', 'notifications')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="
                          export_pdf('notifications_table', 'notifications')
                        "
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    v-model="filters.search_query"
                    @change="applyFilters"
                    class="form-control"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>

          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#notification-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-7 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-secondary waves-effect waves-light"
                    tabindex="0"
                    type="button"
                    :class="{
                      'btn-primary': filters.archived,
                      'btn-secondary': !filters.archived,
                    }"
                    @click.prevent="
                      filters.archived = !filters.archived;
                      applyFilters();
                    "
                  >
                    <span>
                      <i class="ti ti-archive ti-s me-2"></i>
                      <span class=" ">{{
                        $t("notifications.show_archived")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="notifications_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li
                            v-if="
                              hasPrivilege(
                                'notifications_edit_manual_notifications'
                              ) ||
                                hasPrivilege('notifications_push_notifications')
                            "
                          >
                            <button
                              @click="groupArchive()"
                              class="dropdown-item text-secondary"
                            >
                              <i class="ti ti-archive me-2"></i
                              >{{ $t("actions.archive") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th class="sorting" v-if="columns.title.enabled">
                      {{ $t("notifications.title") }}
                    </th>
                    <th class="sorting" v-if="columns.body.enabled">
                      {{ $t("notifications.notification_text") }}
                    </th>
                    <th class="sorting" v-if="columns.type.enabled">
                      {{ $t("notifications.type.type") }}
                    </th>
                    <th class="sorting" v-if="columns.receiver.enabled">
                      {{ $t("notifications.receiver") }}
                    </th>
                    <th class="sorting" v-if="columns.sender.enabled">
                      {{ $t("notifications.sender") }}
                    </th>
                    <th class="sorting" v-if="columns.image.enabled">
                      {{ $t("notifications.image") }}
                    </th>
                    <th class="sorting" v-if="columns.status.enabled">
                      {{ $t("notifications.status") }}
                    </th>
                    <th class="sorting" v-if="columns.created_at.enabled">
                      {{ $t("notifications.created_at") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('notifications_view_notifications')">
                    <th></th>
                    <th></th>
                    <th
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                      v-if="columns.title.enabled"
                    >
                      <input
                        type="text"
                        v-model="filters.title"
                        @change="applyFilters"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                      v-if="columns.body.enabled"
                    >
                      <input
                        type="text"
                        v-model="filters.body"
                        @change="applyFilters"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th rowspan="1" colspan="1" style="border-left: none;">
                      <div style="width: 100px;">
                        <select
                          v-if="
                            hasPrivilege('notifications_view_notifications')
                          "
                          @change="applyFilters"
                          v-model="filters.type"
                          class="form-select w-100"
                          data-style="btn-default"
                        >
                          <option
                            v-for="ft in [
                              { id: '', name: $t('control.all') },
                              {
                                id: 'account_expiring',
                                name: $t('notifications.type.account_expiring'),
                              },
                              {
                                id: 'account_expired',
                                name: $t('notifications.type.account_expired'),
                              },
                              {
                                id: 'account_renew',
                                name: $t('notifications.type.account_renew'),
                              },
                              {
                                id: 'whatsapp',
                                name: $t('notifications.type.whatsapp'),
                              },
                              {
                                id: 'account',
                                name: $t('notifications.type.account'),
                              },
                              {
                                id: 'profile',
                                name: $t('notifications.type.profile'),
                              },
                              { id: 'nas', name: $t('notifications.type.nas') },
                              { id: 'ssr', name: $t('notifications.type.ssr') },
                              {
                                id: 'global',
                                name: $t('notifications.type.global'),
                              },
                            ]"
                            v-bind:key="ft.id"
                            :value="ft.id"
                            >{{ ft.name }}</option
                          >
                        </select>
                      </div>
                    </th>
                    <th
                      v-if="columns.receiver.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        v-if="hasPrivilege('notifications_view_notifications')"
                        @change="applyFilters"
                        v-model="filters.receiver"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.sender.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        v-if="hasPrivilege('notifications_view_notifications')"
                        type="text"
                        @change="applyFilters"
                        v-model="filters.sender"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th v-if="columns.image.enabled"></th>
                    <th
                      v-if="columns.status.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <div style="width: 100px;">
                        <select
                          v-if="
                            hasPrivilege('notifications_view_notifications')
                          "
                          @change="applyFilters"
                          v-model="filters.status"
                          class="form-select w-100"
                          data-style="btn-default"
                        >
                          <option
                            v-for="ft in [
                              { id: '', name: $t('control.all') },
                              { id: 'new', name: $t('notifications.new') },
                              {
                                id: 'archived',
                                name: $t('notifications.archived'),
                              },
                            ]"
                            v-bind:key="ft.id"
                            :value="ft.id"
                            >{{ ft.name }}</option
                          >
                        </select>
                      </div>
                    </th>
                    <th
                      v-if="columns.created_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        v-if="hasPrivilege('notifications_view_notifications')"
                        @change="applyFilters"
                        v-model="filters.created_at"
                        type="datetime-local"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        id="flatpickr-datetime"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr
                    v-for="(notification, index) in dataList"
                    :key="notification.id"
                  >
                    <td>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li
                            v-if="
                              hasPrivilege(
                                'notifications_edit_manual_notifications'
                              ) ||
                                hasPrivilege('notifications_push_notifications')
                            "
                          >
                            <button
                              @click="archiveData(notification)"
                              class="dropdown-item text-secnodary"
                            >
                              <i class="ti ti-archive me-2"></i
                              >{{ $t("actions.archive") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td scope="row">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="notification.selected"
                        @click="selectData(notification)"
                      />
                    </td>
                    <td v-if="columns.title.enabled">
                      {{ notification.title }}
                    </td>
                    <td
                      v-if="columns.body.enabled"
                      style="white-space:pre-wrap; word-wrap:break-word; direction:rtl"
                    >
                      {{ notification.body }}
                    </td>
                    <td>
                      <span
                        class="badge bg-label-primary me-1"
                        :class="{
                          'bg-label-secondary ':
                            notification.type == 'account_expired',
                          'bg-label-warning ':
                            notification.type == 'account_expiring',
                          'bg-label-success ':
                            notification.type == 'account_renew',
                          ' bg-label-primary ':
                            notification.type == 'account' ||
                            notification.type == 'profile' ||
                            notification.type == 'nas',
                          ' bg-label-info text-indigo-200 ':
                            notification.type == 'ssr',
                          ' bg-label-dark ': notification.type == 'global',
                          'bg-label-warning ': notification.type.includes(
                            'support'
                          ),
                        }"
                        >{{
                          $t(`notifications.type.${notification.type}`)
                        }}</span
                      >
                    </td>
                    <td v-if="columns.receiver.enabled">
                      {{ notification.receiver }}
                    </td>
                    <td v-if="columns.sender.enabled">
                      {{ notification.sender }}
                    </td>
                    <td v-if="columns.image.enabled"></td>
                    <td>
                      <span
                        class="badge me-1"
                        :class="{
                          'bg-label-success': notification.status == 'new',
                          'bg-label-secondary':
                            notification.status == 'archived',
                        }"
                        >{{ $t(`notifications.${notification.status}`) }}</span
                      >
                    </td>
                    <td v-if="columns.created_at.enabled">
                      {{ formatDateHours(notification.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import notificationsAdd from "../components/modals/notifications-add.vue";
import notificationsAuto from "../components/modals/notifications-auto.vue";
import notificationsWhatsapp from "../components/modals/notifications-whatsapp.vue";
import NotificationsSms from "../components/modals/notifications-sms.vue";
import NotificationsTelegram from "../components/modals/notifications-telegram.vue";
export default {
  components: {
    notificationsAdd,
    notificationsAuto,
    notificationsWhatsapp,
    NotificationsSms,
    NotificationsTelegram,
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  name: "Notifications",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showArchive: false,
      showArchiveAll: false,
      loading: true,
      loading_overlay: false,
      showFilters: false,
      showPushNotification: false,
      showAddNotification: false,
      showAutoNotfications: false,
      showWhatsappNotifications: false,
      showSmsNotifications: false,
      showTelegramNotifications: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        title: "",
        body: "",
        type: "",
        receiver: "",
        sender: "",
        image_url: "",
        status: "",
        created_at: "",
        archived: 0,
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        title: {
          name: this.$t("notifications.title"),
          enabled: true,
          sort: false,
        },
        body: {
          name: this.$t("notifications.body"),
          enabled: false,
          sort: false,
        },
        type: {
          name: this.$t("notifications.type.type"),
          enabled: true,
          sort: false,
        },
        receiver: {
          name: this.$t("notifications.receiver"),
          enabled: false,
          sort: false,
        },
        sender: {
          name: this.$t("notifications.sender"),
          enabled: false,
          sort: false,
        },
        image: {
          name: this.$t("notifications.image"),
          enabled: false,
          sort: false,
        },
        status: {
          name: this.$t("notifications.status"),
          enabled: true,
          sort: false,
        },
        created_at: {
          name: this.$t("notifications.created_at"),
          enabled: true,
          sort: false,
        },
      },
      autoUpdate: false,
      selection_array: [],
      sort_col: null,
      sort_dir: null,
      debounce: null,
    };
  },
  async created() {
    this.prepareFilters();
    this.prepareColumns();
    this.applyFilters();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    prepareFilters() {
      var filters = localStorage.getItem("notifications_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("notifications_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          title: {
            name: this.$t("notifications.title"),
            enabled: cols[0].enabled,
            sort: false,
          },
          body: {
            name: this.$t("notifications.body"),
            enabled: cols[1].enabled,
            sort: false,
          },
          type: {
            name: this.$t("notifications.type.type"),
            enabled: cols[2].enabled,
            sort: false,
          },
          receiver: {
            name: this.$t("notifications.receiver"),
            enabled: cols[3],
            sort: false,
          },
          sender: {
            name: this.$t("notifications.sender"),
            enabled: cols[4].enabled,
            sort: false,
          },
          image: {
            name: this.$t("notifications.image"),
            enabled: cols[5].enabled,
            sort: false,
          },
          status: {
            name: this.$t("notifications.status"),
            enabled: cols[6].enabled,
            sort: false,
          },
          created_at: {
            name: this.$t("notifications.created_at"),
            enabled: cols[7].enabled,
            sort: false,
          },
        };
      }
    },
    sort(param) {
      this.sort_col = param;
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "notifications?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.tile != "")
        requestString += `&title=${this.filters.title}`;
      if (this.filters.body != "")
        requestString += `&body=${this.filters.body}`;
      if (this.filters.type != "")
        requestString += `&type=${this.filters.type}`;
      if (this.filters.receiver != "")
        requestString += `&receiver=${this.filters.receiver}`;
      if (this.filters.sender != "")
        requestString += `&sender=${this.filters.sender}`;
      if (this.filters.status != "")
        requestString += `&status=${this.filters.status}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.archived)
        requestString += `&archived=${this.filters.archived}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = Object.values(response.data.data);
      if (this.filters.save)
        localStorage.setItem(
          "notifications_filters",
          JSON.stringify(this.filters)
        );
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = Object.values(response.data.data);
      //   if (this.filters.save)
      //     localStorage.setItem(
      //       "notifications_filters",
      //       JSON.stringify(this.filters)
      //     );
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   clearTimeout(this.debounce);
      //   this.meta = response.data.meta;
      //   this.loading = false;
      // }, 1000);
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    async showAddNotificationDialog(notification = null) {
      this.showAddNotification = true;
      if (notification) {
        this.$router.push({
          query: { notification_id: notification.id },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-notification");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddNotification = false;
      });
      modalInstance.show();
    },
    async showAutoNotificationsDialog() {
      this.showAutoNotfications = true;
      await this.$nextTick();
      var modalElement = document.getElementById("auto-notifications");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAutoNotfications = false;
      });
      modalInstance.show();
    },
    async showWhatsappNotificationsDialog() {
      this.showWhatsappNotifications = true;
      await this.$nextTick();
      var modalElement = document.getElementById("whatsapp-notifications");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showWhatsappNotifications = false;
      });
      modalInstance.show();
    },
    async showSmsNotificationsDialog() {
      this.showSmsNotifications = true;
      await this.$nextTick();
      var modalElement = document.getElementById("sms-notifications");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showSmsNotifications = false;
      });
      modalInstance.show();
    },
    async showTelegramNotificationsDialog() {
      this.showTelegramNotifications = true;
      await this.$nextTick();
      var modalElement = document.getElementById("telegram-notifications");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showTelegramNotifications = false;
      });
      modalInstance.show();
    },
    async archiveData(ticket) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("notifications.this_will_archive_notification"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`notifications/${ticket.id}`);
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("notifications.archived"),
              text: this.$t("notifications.notification_archived"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            console.log(error);

            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupArchive() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "notifications.this_will_archive_all_selected_notifications"
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("control.yes"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`notifications/group/archive`, {
              notifications: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("notifications.archived"),
              text: this.$t("notifications.notifications_archived"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatDateHours(date) {
      //todo fix UTC BUG
      if (date == "never" || date == "" || date == null) return "N/A";
      return moment(date)
        .add(3, "hours")
        .format("DD-MM-YYYY hh:mm");
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns() {
      localStorage.setItem(
        "notifications_columns",
        JSON.stringify(Object.values(this.columns))
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem(
        "notifications_filters",
        JSON.stringify(this.filters)
      );
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
